import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  return {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: params.dateHierarchy,
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
  };
};
